import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, Users, Film } from "lucide-react";
import { api } from "@/lib/api";
import { countryFlag, countryName } from "@/lib/constants";

export default function Creators() {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/creators").then((r) => setCreators(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center"><div className="w-10 h-10 border-4 border-[#E50914] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-10 py-8">
      <h1 className="font-display font-black text-3xl sm:text-4xl mb-1">Creators</h1>
      <p className="text-white/50 text-sm mb-8">Meet the storytellers powering African cinema.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="creators-grid">
        {creators.map((c) => (
          <Link key={c.id} to={`/creator/${c.id}`} data-testid={`creator-card-${c.id}`}
            className="group rounded-2xl overflow-hidden bg-[#1A1724] border border-white/5 hover:border-[#E50914]/40 transition-all hover:-translate-y-1">
            <div className="relative h-28">
              {c.banner ? <img src={c.banner} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-[#E50914]/30 to-[#D4AF37]/20" />}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1724] to-transparent" />
            </div>
            <div className="px-5 pb-5 -mt-8 relative">
              {c.avatar ? <img src={c.avatar} alt={c.display_name} className="w-16 h-16 rounded-full border-4 border-[#1A1724] object-cover" />
                : <span className="w-16 h-16 rounded-full border-4 border-[#1A1724] bg-[#D4AF37]/40 flex items-center justify-center text-2xl font-bold">{c.display_name?.[0]}</span>}
              <h3 className="font-display font-bold text-lg mt-2 flex items-center gap-1">
                {c.display_name} {c.verified && <BadgeCheck className="w-4 h-4 text-[#E50914]" />}
              </h3>
              <p className="text-xs text-white/50 mt-1 line-clamp-2 h-8">{c.bio}</p>
              <div className="flex items-center gap-4 mt-3 text-xs text-white/60">
                <span className="flex items-center gap-1">{countryFlag(c.country)} {countryName(c.country)}</span>
                <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {c.follower_count?.toLocaleString()}</span>
                <span className="flex items-center gap-1"><Film className="w-3.5 h-3.5" /> {c.content_count}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
